"use client";

import React from "react";
import ScrollToTopButton from "./ScrollToTopButton";
import ButtonAsk from "./ButtonAsk";

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      <ScrollToTopButton />
      <ButtonAsk />
    </div>
  );
};

export default FloatingButtons;
